import Stack from '@mui/material/Stack';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import { GradientBorder } from '../gradients/GradientBorder';
import { GradientTypography } from '../gradients/GradientTypography';
import { useMobile } from 'src/hooks/useMobile';
import { useReferee } from 'src/contexts/RefereeContext';
import { useState } from 'react';

export const USEFUL_INFO_BRACKETS = [
  'Click the edit icon to view the details of a match',
  'You can declare the winner or delay/cancel the match from the drawer',
  'If you encounter any issues please contact the BluMint team ASAP',
];

export const USEFUL_INFO_HEATS = [
  'Double click a score cell to update the score',
  'You can edit the display of the columns, and that of the details column, using the toolbar',
  'The rankings and prizes will recalculate automatically once you press enter',
  'If you encounter any issues please contact the BluMint team ASAP',
];

export type RefereeHeaderProps = {
  info?: string[];
};

export const RefereeHeader = ({
  info = USEFUL_INFO_BRACKETS,
}: RefereeHeaderProps) => {
  const isMobile = useMobile();
  const { setIsRefereeView } = useReferee();
  const [showGuide, setShowGuide] = useState(false);

  return (
    <Stack
      direction={isMobile ? 'column-reverse' : 'row'}
      justifyContent="space-between"
    >
      <Stack
        direction="column"
        alignItems="center"
        flex={1}
        spacing={2}
        sx={{
          opacity: !!showGuide ? 1 : 0,
          pl: isMobile ? 0 : '228px',
        }}
      >
        <GradientTypography
          variant="h5"
          gradientColor="primary.vertical"
          textTransform="uppercase"
        >
          How To Use:
        </GradientTypography>
        <GradientBorder borderRadius="8px">
          <Stack justifyContent="center" sx={{ mx: 4, my: 2 }}>
            {info.map((point) => {
              return (
                <Typography key={point} component="li">
                  {point}
                </Typography>
              );
            })}
          </Stack>
        </GradientBorder>
      </Stack>
      <FormGroup sx={{ pr: 6, justifySelf: 'flex-end' }}>
        <FormControlLabel
          control={
            <Switch
              onChange={() => {
                setIsRefereeView((prev) => {
                  return !prev;
                });
                setShowGuide((prev) => {
                  return !prev;
                });
              }}
            />
          }
          label={
            <GradientTypography variant="h5" gradientColor="primary.vertical">
              Referee View
            </GradientTypography>
          }
          labelPlacement="start"
        />
      </FormGroup>
    </Stack>
  );
};
